<template>
  <DetailCard title="Contato">
    <div class="flex flex-col gap-3">
      <DetailField :icon="mdiEmailOutline" label="E-mail">
        <a
          v-if="email"
          :href="`mailto:${email}`"
          data-testid="doctor-contact-email"
          class="text-primary30 hover:underline"
        >
          {{ email }}
        </a>
        <span v-else data-testid="doctor-contact-email" class="font-normal text-gray-400">
          Não informado
        </span>
      </DetailField>

      <DetailField :icon="mdiPhoneOutline" label="Telefone">
        <a
          v-if="phone"
          :href="`tel:${phoneDigits}`"
          data-testid="doctor-contact-phone"
          class="text-primary30 hover:underline"
        >
          {{ phone }}
        </a>
        <span v-else data-testid="doctor-contact-phone" class="font-normal text-gray-400">
          Não informado
        </span>
      </DetailField>

      <DetailField v-if="location" :icon="mdiMapMarkerOutline" label="Localização">
        <span data-testid="doctor-contact-location">{{ location }}</span>
      </DetailField>
    </div>
  </DetailCard>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { mdiEmailOutline, mdiPhoneOutline, mdiMapMarkerOutline } from '@mdi/js'

import type { DoctorDetailResponse } from '@/Network/Types/Responses/CompanyResponses'
import DetailCard from '../atoms/DetailCard.vue'
import DetailField from '../atoms/DetailField.vue'
import { formatPhone } from '@/utils/formatters'

const props = defineProps<{
  doctor: DoctorDetailResponse
}>()

const email = computed(() => props.doctor.doctor.user?.email || null)
const rawPhone = computed(() => props.doctor.doctor.user?.mainPhone?.phoneNumber || null)
const phone = computed(() => (rawPhone.value ? formatPhone(rawPhone.value) : null))
const phoneDigits = computed(() => rawPhone.value?.replace(/\D/g, '') ?? '')
const city = computed(() => props.doctor.doctor.user?.mainAddress?.city)
const uf = computed(() => props.doctor.doctor.user?.mainAddress?.state)

const location = computed(() => {
  if (city.value && uf.value) return `${city.value} - ${uf.value}`
  return city.value || uf.value || ''
})
</script>
